import { useCallback } from "react";
import { clinicianPortalApi } from "../api/clinicianPortalApi";
import { usePortalData } from "./usePortalData";
import { ClientAccessScope } from "../api/contracts";

export function useClientExpectancies(
  clinicianCode: string,
  patientId: string,
  accessScope: ClientAccessScope = "assigned",
) {
  const request = useCallback(
    (signal: AbortSignal) =>
      accessScope === "team"
        ? clinicianPortalApi.getExpectancies(
            clinicianCode,
            patientId,
            signal,
            "team",
          )
        : clinicianPortalApi.getExpectancies(clinicianCode, patientId, signal),
    [accessScope, clinicianCode, patientId],
  );

  return usePortalData(request);
}
